import * as lazyIndex from './lazyIndex';
import { ComponentClass } from 'react';
import { ConfirmCustomizationOptions } from './schema/ConfirmCustomizationOptions';
import { createLazyComponent, LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { DialogResponse } from './schema/DialogResponse';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(
        /* webpackChunkName: "ConfirmDialog", webpackPrefetch: true */ './lazyIndex'
    )
);

const lazyConfirm = new LazyImport(lazyModule, m => m.confirmAction);
export function confirm(
    title: string,
    resolveImmediately?: boolean,
    customizationOptions?: ConfirmCustomizationOptions
): Promise<DialogResponse> {
    return lazyConfirm
        .import()
        .then(concreteConfirm => concreteConfirm(title, resolveImmediately, customizationOptions));
}

export const ConfirmDialog = createLazyComponent(lazyModule, m => m.ConfirmDialog);

// TODO: Avoid using lazyShowConfirmDialogInBottomSheet instead use confirm function above. WI: 52569
export const lazyShowConfirmDialogInBottomSheet = new LazyAction(
    lazyModule,
    m => m.showConfirmDialogInBottomSheet
);

export { ComponentClass };
export { ConfirmCustomizationOptions, DialogResponse };
